/* eslint-disable no-restricted-syntax */

// в русском языке для количественных переводов требуется 3 ключа: one, few, many
// если many не указан, то в качестве перевода берется сам ключ

const intlMap = {
    '_privacy-policy': {
        prefix: 'Сайт использует cookie-файлы в соответствии с ',
        link: 'Политикой конфиденциальности',
        suffix: ', чтобы персонализировать информацию для Вас. Вы можете запретить обработку cookie в настройках Вашего браузера.',
        accept: 'Принять',
    },
    Тарифы: '',
    Выход: '',
    'О платформе': '',
    Имя: '',
    Хранилище: '',
    Минуты: '',
    Роль: '',
    Статус: '',
    Активен: '',
    Удален: '',
    Задачи: '',
    'Моделей дикторов': '',
    'Хранилище, ГБ': '',
    'Одновременно обрабатываемых задач': '',
    'Символов в запросе на синтез': '',
    'Запросов на синтез в секунду': '',
    'Скачать CSV': '',
    'История потребления %0': '',
    Месяц: '',
    'Нет данных': '',
    'Нет доступных голосов': '',
    'аккаунты.экспорт.файл.имя': 'аккаунты от %0',
    'аккаунты.экспорт.столбцы': ['логин', 'роль', 'статус', 'использованных минут', 'емкость хранилища', 'одновременных задач'],
    'Дата регистрации': '',
    'По запросу': '',
    'Заявка отправлена': '',
    'Использовано %0 из %1.html': 'Использовано <b>%0</b> из <b>%1</b>',
    'Удалить %0 файлов?': {one: 'Удалить %0 файл?', few: 'Удалить %0 файла?'},
    'Будут удалены %0 файлов': {one: 'Будет удален %0 файл', few: 'Будут удалены %0 файла'},
    'Выбраны %0 файлов': {one: 'Выбран %0 файл', few: 'Выбраны %0 файла'},
    'Загружается %0 файлов': {one: 'Загружается %0 файл', few: 'Загружается %0 файла'},
    'Распознавание речи': '',
    'Для разработчиков': '',
    'Информация для разработчиков': '',
    'Идентификатор клиента': '',
    'Секретный ключ': '',
    'Голос синтеза': '',
    'Забыли пароль?': '',
    'Восстановление пароля': '',
    Восстановить: '',
    'E-mail, указанный при регистрации': '',
    'На указанный адрес направлены инструкции по изменению пароля': '',
    'Скорость воспроизведения': '',
    Вход: '',
    'E-mail': '',
    Компания: '',
    Пароль: '',
    'Придумайте пароль': '',
    'Повторите пароль': '',
    'Придумайте новый пароль': '',
    'Пароли не совпадают': '',
    'Пароль изменён': '',
    'Ограничение длины %0 символов': {one: 'Ограничение длины %0 символ', few: 'Ограничение длины %0 символа'},
    'Ограничение превышено: %0/%1 символов': {one: 'Ограничение превышено: %0/%1 символ', few: 'Ограничение превышено: %0/%1 символа'},
    'Новый пароль': '',
    Войти: '',
    'Синтез речи': '',
    Регистрация: '',
    Зарегистрироваться: '',
    Документация: '',
    'Имя файла': '',
    'Дата загрузки': '',
    'Дата обработки': '',
    Длительность: '',
    Размер: '',
    Модель: '',
    Удалить: '',
    Найти: '',
    Применить: '',
    'Загружайте один или несколько файлов, максимальный размер файла 500 MБ': '',
    'Удалить?': '',
    Загрузить: '',
    '_register.success.header': 'Вы успешно зарегистрированы',
    '_register.success.message': [
        'На указанный адрес отправлено письмо со ссылкой.\n',
        'Для подтверждения регистрации необходимо перейти по ссылке.',
    ],
    Скачать: '',
    Переобработать: '',
    'расшифровка %0': '',
    'Скачать расшифровку': '',
    'Достоверность: %0': '',
    'Голос #%0': '',
    'Конец записи': '',
    'Настроить распознавание речи': '',
    'Настройки распознавания речи': '',
    'Снять выделение': '',
    Скопировано: '',
    'Подать заявку': '',
    'Оставьте заявку': '',
    'мы с вам свяжемся': '',
    'Частота дискретизации': '',
    'Подставить пример': '',
    API: '',
    Сохранить: '',
    Выбрать: '',
    'Результатов не найдено': '',
    Язык: '',
    '© %0 3iTech Все права принадлежат ООО “ДСС Лаб”': '',
    _error: {
        34: 'Что-то пошло не так',
        35: 'Что-то пошло не так',
        36: 'Что-то пошло не так',
        37: 'Что-то пошло не так',
        54: 'Что-то пошло не так',
        62: 'Что-то пошло не так',
        500: 'Недостаточно места',
        'frontend:1': 'Что-то пошло не так',
        'frontend:2': 'Неверное имя пользователя или пароль',
        'frontend:3': 'Невозможно воспроизвести данный файл',
        'frontend:4': 'Ошибка при распознавании',
    },
    '_popup.message': 'Уведомление',
    '_popup.error': 'Ошибка',
    _sentiment: {
        positive: 'Позитив',
        negative: 'Негатив',
        neutral: 'Нейтраль',
    },
    '_synthesis.speeds': {
        0.8: '0,8x',
        0.9: '0,9x',
        1: '1,0x',
        1.1: '1,1x',
        1.2: '1,2x',
    },
    '_synthesis.sample-rate': {
        22050: '22050 Гц',
        16000: '16000 Гц',
        8000: '8000 Гц',
    },
    '_synthesis.filename': 'синтез %0 %1',
    '_languages.autoselect': 'Автовыбор языка',
    _languages: {
        az: 'Азербайджанский',
        tr: 'Турецкий',
        ar: 'Арабский',
        zh: 'Китайский',
        uk: 'Украинский',
        pl: 'Польский',
        en: 'Английский',
        kk: 'Казахский',
        ru: 'Русский',
        uz: 'Узбекский',
    },
    '_task.status': {
        complete: 'Обработан',
        error: 'Ошибка',
        process: 'В обработке',
        deleted: 'Удалена',
    },
    '_chat.message.title': '[%1] Собеседник %0:',
    '_asr.parameters': {
        process_with_sd: 'Включить детектор речи',
        enable_automatic_punctuation: 'Расставлять знаки препинания',
        word_to_number: 'Преобразовать числительные в цифры',
        sentiment_analysis: 'Выделять эмоциональность',
        diarization: 'Включить диаризацию',
        thresholds_greedy: 'Порог символьной достоверности фразы',
        thresholds_am: 'Порог акустической достоверности слова',
    },
    Технология: '',
    'Технические характеристики': '',
    Синтез: '',
    'Список голосов': '',
    'Нормализация текста': '',
    'Разметка текста': '',
    'Search-параметры': '',
    'Path-параметры': '',
    'Тело запроса': '',
    Обзор: '',
    Распознавание: '',
    Дикторы: '',
    Запрос: '',
    Ответ: '',
    Авторизация: '',
    Профиль: '',
    'Эмоциональная окраска': '',
    '_landing.boxes': {
        1: {
            header: 'Обрабатывайте речь с 3i VoxKit',
            texts: [
                '3i VoxKit – облачная AI-платформа для создания любых продуктов и ',
                'бизнес решений на основе речевых технологий 3iTech',
            ],
        },
        2: {
            header: 'Области применения',
            subtitle: 'Используйте 3i VoxKit для решения бизнес задач, где требуется распознавать, понимать и идентифицировать речь.',
            blocks1: [
                {title: 'Озвучивание контента', texts: 'Озвучивайте любой контент: видеоролики, аудиокниги, инструкции, интерфейс сайта.'},
                {title: 'Голосовые роботы', texts: [
                    'Научите ваших голосовых роботов и ассистентов ',
                    'общаться на естественном языке с помощью 3i VoxKit.',
                ]},
                {title: 'Протоколирование совещаний', texts: [
                    'Используйте 3i VoxKit в системах протоколирования ',
                    'офлайн совещаний и онлайн конференций.',
                ]},
            ],
            blocks2: [
                {title: 'Защита бизнеса от фрода', texts: [
                    'Узнавайте своих клиентов по голосу на любом языке. ',
                    'Сократите время на идентификацию клиентов и минимизируйте риски от мошеннических действий.',
                ]},
                {title: 'Системы речевой аналитики', texts: [
                    'Используйте технологии 3i VoxKit при создании решений ',
                    'для автоматизации анализа клиентский коммуникаций ',
                    'и контроля качества обслуживания.',
                ]},
                {title: 'Субтитры для ТВ и фильмов', texts: 'Создавайте субтитры для ТВ-передач, эфиров, подкастов или видеофильмов.'},
            ],
        },
        3: {
            header: 'Brand Voice',
            subtitle: 'Создадим уникальный голос под ваши бизнес задачи.',
            blocks: [
                'Для старта потребуется всего 30+ часов аудиозаписей диктора.',
                'Мы поможем с текстами для диктора, профессиональной студией и звуком.',
                'Две недели после записи, и ваш фирменный голос готов!',
            ],
        },
        4: {
            header: 'Протестируйте самостоятельно',
            blocks: {
                speechRecognition: {
                    title: 'Распознавание речи',
                    placeholder: 'Нажмите кнопку “Записать речь”, включите микрофон в браузере и говорите',
                    recordButton: 'Записать речь',
                    stopButton: 'Остановить запись',
                    checkboxes: {
                        punctuate: 'Расставлять знаки препинания',
                        numeral: 'Преобразовывать числительные',
                        emotions: 'Определять эмоции',
                    },
                },
                speechSynthesis: {
                    title: 'Синтез речи',
                    start: 'Воспроизвести',
                    pause: 'Пауза',
                    resume: 'Продолжить',
                    synthesizeSpeech: 'Синтезировать речь',
                },
            },
        },
        5: {
            header: 'Функциональные особенности 3i VoxKit',
            subtitle: 'Оцените технические возможности для эффективной обработки речевых данных.',
            blocks: [
                {
                    title: 'Синтез речи',
                    texts: [
                        [
                            'Произнесение аббревиатур.',
                            'Автоматическая постановка ударений.',
                            'Использование пауз.',
                            'Интонирование речи в соответствии с общепринятыми правилами.',
                        ],
                        'Управление синтезом с помощью простой текстовой разметки или SSML-тегов.',
                        'Синтез речи на русском и казахском языках.',
                        'Поддержка аудио шаблонов и предзаписанного аудио.',
                    ] as const,
                },
                {
                    title: 'Распознавание речи',
                    texts: [
                        'Транскрибация с точностью более 95% (телефония).',
                        'Определение пола, возраста и эмоций в канале оператора и клиента.',
                        'Автоматическое определение языка.',
                        'Автоматическая расстановка знаков препинания.',
                        'Поддерживаемые языки: русский, английский, казахский и узбекский, в т.ч. смешанная речь.',
                        'Автоматическое разделение дикторов в моно-записях.',
                    ],
                },
                {
                    title: 'Голосовая биометрия',
                    texts: [
                        'Текстонезависимая технология, не зависит от языка.',
                        'Голосовая идентификация с точностью до 98%.',
                        'Создание голосовых «слепков» от 20 сек естественной речи.',
                        'Голосовая идентификация и верификация от 5 сек.',
                    ],
                },
            ],
        },
        6: {
            header: 'Создание уникального голоса',
            texts: [
                'Мы предлагаем воспользоваться возможностью создания уникального голоса ',
                'под ваши бизнес-задачи',
            ],
        },
        7: {
            header: 'Вопросы и ответы',
            blocks: [
                {
                    title: 'Распознавание речи (ASR). Что это такое? Как это работает?',
                    texts: [
                        `Распознавание речи (ASR – Automatic Speech Recognition) – автоматический процесс считывания аудио-потока
                         и преобразования его в текст. `,
                        [
                            'В основе работы этой технологии – нейросети, которые необходимо обучать. ',
                            `Процесс обучения начинается с определенного набора данных, на основе которого нейросеть учится сопоставлять звуки
                            и буквы.`,
                            `Новый язык – все сначала. Технология распознавания речи активно используется в бизнесе: голосовой поиск в сервисах
                            (навигатор, такси, виртуальный голосовой помощник в смартфоне), голосовое меню во время телефонного звонка для адресации
                            по запросу, анализ телефонных разговоров с клиентами, проведение телефонных опросов.`,
                        ],
                    ],
                },
                {
                    title: 'Синтез речи (TTS). Что это такое? Как это работает?',
                    texts: [
                        'Синтез речи (TTS – Text to Speech) – автоматический процесс преобразования печатного текста в речь.',
                        [
                            `И в основе работы этой технологии также лежат нейросети, которые необходимо обучать, для этого создаются наборы
                            данных – аудиозаписи с разными голосами и темами и специальной разметкой. Главная задача сделать так, чтобы
                            синтезированная речь звучала максимально как человеческая. Модель синтеза речи применяется при озвучивании любого
                            текста: создание субтитров, озвучивание аудио- и видеороликов, запись аудиокниг, создание голосовой навигации на сайтах,
                            подключение автоответчика, автоматизация работы операторов, работа виртуальных ассистентов, голосовые системы навигации.`,
                        ],
                    ],
                },
                {
                    title: 'Какие языки поддерживаются в 3i VoxKit?',
                    texts: [
                        'Распознавание речи (ASR): русский, английский, казахский, узбекский, азербайджанский.',
                        'Синтез речи (TTS): русский, казахский',
                    ],
                },
                {
                    title: 'Голосовая биометрия. Что это такое?',
                    texts: [
                        'Голосовая биометрия – система распознавания личности человека, основанная на уникальных характеристиках его голоса.',
                        [
                            `Технология применяется в крупных контактных центрах. Использование голосовой биометрии решает две основные задачи
                            в бизнесе: голосовая идентификация человека и последующая его верификация. Это минимизирует уточняющие вопросы для
                            подтверждения личности, тем самым сокращает время обслуживания и повышает лояльность клиентов. С помощью голосовой
                            биометрии вы сможете защитить ваш бизнес от телефонного мошенничества.`,
                        ],
                    ],
                },
                {
                    title: 'Как работает голосовая биометрия в 3i VoxKit?',
                    texts: [
                        'Голосовая биометрия в 3i VoxKit текстонезависимая, и может применяться для работы с любым языком.',
                        [
                            'Для формирования уникального голосового слепка (вектора) требуется от 15 до 30 сек. естественной речи.',
                        ],
                    ],
                },
                {
                    title: 'Кто может использовать 3i VoxKit?',
                    texts: [
                        [
                            `Технологии 3i VOХ предназначены для разработчиков ПО и сервисов для внедрения функции распознавания, синтеза и
                            идентификации и/или верификации речи в программы, мобильные или web-сервисы для конечных пользователей или коммерческим
                            компаниям для разработки бизнес-решений, где требуется понимать и идентифицировать речь, например, автоматизация
                            телефонии, анализ работы персонала и качества сервиса. Например, такие отрасли бизнеса как контакт-центры компаний
                            розничной торговли, финансовые компании, медицинские центры, строительные компании, операторы связи, агентства
                            недвижимости, СМИ, мультимедийные платформы, стриминговые видеосервисы`,
                        ],
                    ],
                },
                {
                    title: 'Как можно подключить 3i VoxKit?',
                    texts: [
                        '3i VoxKit доступен в облаке (SaaS) по протоколам REST API и gRPC или может быть развернут локально (On-premise).',
                        'Также возможна гибридная реализация (Hybrid).',
                    ],
                },
                {
                    title: 'Как оплатить доступ к 3i VoxKit',
                    texts: [
                        'Для доступа к облачному сервису необходимо заключить договор.',
                    ],
                },
            ],
        },
        8: {
            header: 'Преимущества технологии 3i VoxKit',
            subtitle: 'Воспользуйтесь безопасными и надежными технологиями обработки речи с простой интеграцией и гибкими настройками внедрения.',
            blocks: [
                {
                    title: 'Простая интеграция',
                    texts: [
                        'Быстрое встраивание технологии распознавания речи в любые кроссплатформенные приложения и сервисы.',
                    ],
                },
                {
                    title: ['Внедрение'],
                    list: [
                        'On-Premise/ Hybrid – возможность полного или частичного развертывания ПО на серверах Заказчика.',
                        'Поддержка GPU- и CPU-вычислений для распознавания и синтеза речи.',
                        'Поддержка ОС Astra Linux CE / SE.',
                    ],
                },
                {
                    title: 'Безопасность и надежность',
                    texts: [
                        'Бесперебойная работа платформы и надежное хранение данных благодаря размещению в крупнейшем российском дата-центре.',
                    ],
                },
            ],
        },
        9: {
            header: 'Тарифы',
            blocks: {
                recognition: {
                    title: 'Распознавание речи',
                    subTitle: 'SaaS',
                    costs: [
                        ['Онлайн-обработка файла', '0,45 руб.', 'за 1 мин.'],
                        ['Онлайн-обработка потока', '0,69 руб.', 'за 1 мин.'],
                        ['Отложенная обработка', '0,16 руб.', 'за 1 мин.'],
                    ],
                    additional: [
                        'Честная посекундная тарификация, без округлений.',
                        'Единая стоимость для моно- и стерео-записей.',
                        'При распознавании более 1 млн минут в месяц – индивидуальные условия.',
                    ],
                    footer: {
                        left: 'On-premise / Hybrid',
                        right: [
                            'Разработка нового языка',
                            'Дообучение ML-модели',
                        ],
                    },
                },
                synthesis: {
                    subTitle: 'SaaS',
                    title: 'Синтез речи',
                    costs: [
                        'Потоковый синтез речи – 590 руб. / 1 млн символов.',
                        'Позапросно – 0,2 руб. (1 запрос до 20 сек. / 500 симв.)',
                    ],
                    note: '* минимум 10 000 руб./мес.',
                    footer: {
                        left: 'On-premise / Hybrid',
                        right: [
                            'Brand Voice',
                            'Создание уникального голоса',
                        ],
                    },
                },
            },
        },
        10: {
            header: 'Обсудим проект?',
            subtitle: 'Чтобы узнать подробнее о 3i VoxKit и получить индивидуальные условия – заполните, пожалуйста, форму.',
            form: {
                name: 'Имя *',
                email: 'E-mail *',
                company: 'Компания *',
                phone: '+7 (999) 999-99-99',
                deliveryType: 'Тип поставки',
                suggest: 'Описание задачи / тема предложения',
                personalData: ['Я соглашаюсь с', 'Правилами обработки персональных данных'],
                advertisements: 'Я хочу получать новостные и рекламные письма.',
            },
            texts: [
                'Мы предлагаем воспользоваться возможностью создания уникального голоса ',
                'под ваши бизнес-задачи',
            ],
        },
        11: {
            header: 'Партнеры',
            icons: [
                // 'profit',
                ['voca', 'https://voca.tech/'],
                ['shtormtech', 'https://www.shtormtech.ru/'],
                ['neuro', 'https://neuro.net/ru/'],
                ['just-ai', 'https://just-ai.com/'],
                ['speechmate', 'https://speechmate.ru/'],
                // 'naumen',
                ['search-inform', 'https://searchinform.ru/'],
                ['softline', 'https://softline.ru/'],
                // 'mango-office',
                // 'amt-group',
                ['digitalDesign', 'https://digdes.ru/'],
                ['aurus', 'https://aurus5.ru/'],
                ['cti', 'https://www.cti.ru/'],
                ['croc', 'https://www.croc.ru/'],
                ['unistar', 'https://unistar.ru/'],
                // 'аргус-нтц',
                ['voxys', 'https://www.voxys.ru/'],
                // 'infoqubes',
            ],
        },
        12: {
            about: 'О платформе',
            api: 'API',
            docs: 'Документация',
            politics: 'Политика конфиденциальности',
            social: {
                title: 'Мы в соцсетях',
                icons: [
                    ['vk', 'https://vk.com/3itech'],
                    ['youtube', 'https://www.youtube.com/channel/UCIonGZ4UnpGetLL_DRPr1og'],
                ],
            },
            contacts: {
                phone: ['+7 (495) 645-44-70', 'tel:+74956454470'],
                location: ['129329, Москва, ул. Кольская д.2, корп.6', 'https://yandex.ru/maps/-/C2SEF9C'],
                email: ['Info@3itech.ru', 'mailto:info@3itech.ru'],
            },
        },
    },
}

export default intlMap

export type IntlMap = typeof intlMap
